









































































































































































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class DialogExtremeImport extends Vue {
  showExDialog: boolean = false;

  open() {
    this.showExDialog = true;
  }

  close() {
    this.showExDialog = false;
  }
}
